export default __webpack_public_path__ + "static/media/bgBlueInsidebgBlue30.5x21.1446d5d4.jpg";